module.exports = __webpack_public_path__ + "img/logodv.575204a1.png";